const { useState } = require("react");

export function RemarkField({ remark }) {
    const [expanded, setExpanded] = useState(false);
  
    return (
      <div
        onClick={() => setExpanded(!expanded)}
        style={{
          cursor: 'pointer',
          whiteSpace: 'pre-line',
          overflowY: expanded ? 'auto' : 'hidden',
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: expanded ? 5 : 2,
          maxHeight: expanded ? '7.5em' : '3em', // 5x1.5em / 2x1.5em
          lineHeight: '1.5em',
          minHeight: '2.5em',
          border: '1px solid #e9ebec',
          borderRadius: '.25rem',
          padding: '.375rem .75rem',
          fontSize: '0.8rem',
          userSelect: 'text',
          backgroundColor: '#fff',
          width: '100%', // Full width of container
          flexGrow: 1 // Added for parent flex
        }}
      >
        {remark}
      </div>
    );
  }
  